<nb-card>

  <nb-card-header>
    Editar Recinto
  </nb-card-header>

  <nb-card-body
    [nbSpinner]="loading || cargandoDatos"
    nbSpinnerStatus="danger"
    nbSpinnerSize="large"
    nbSpinnerMessage="Guardando cambios...">

    <div class="scrollable-content">

      <form autocomplete="off">

        <!-- Nombre -->
        <div class="form-group">
          <label>Nombre</label>

          <input
            nbInput
            fullWidth
            type="text"
            [(ngModel)]="alias"
            name="alias"
            [disabled]="loading"
            class="campo-formulario" />
        </div>


        <!-- Código DGC -->
        <div class="form-group">
          <label>Código DGC</label>

          <input
            nbInput
            fullWidth
            type="text"
            [(ngModel)]="codigoDGC"
            name="codigoDGC"
            [disabled]="loading"
            class="campo-formulario" />
        </div>


        <!-- Cultivo -->
        <div class="form-group">
          <label>Cultivo</label>

          <nb-select
            fullWidth
            placeholder="Selecciona un cultivo"
            [(selected)]="cultivoSeleccionado"
            name="cultivo"
            [disabled]="loading || cargandoDatos"
            (selectedChange)="cambioCultivo()">

            <nb-option
              *ngFor="let cultivo of cultivos"
              [value]="cultivo.identifier">

              {{ cultivo.name }}

            </nb-option>

          </nb-select>
        </div>


        <!-- Variedad -->
        <div class="form-group">
          <label>Variedad</label>

          <nb-select
            fullWidth
            placeholder="Selecciona una variedad"
            [(selected)]="variedadSeleccionada"
            name="variedad"
            [disabled]="
              loading ||
              cargandoDatos ||
              cultivoSeleccionado == null
            ">

            <nb-option
              *ngFor="let variedad of variedadesFiltradas"
              [value]="variedad.identifier">

              {{ variedad.name }}

            </nb-option>

          </nb-select>
        </div>

      </form>

    </div>

  </nb-card-body>


  <nb-card-footer>

    <button
      nbButton
      shape="round"
      size="small"
      status="danger"
      [disabled]="loading"
      (click)="cerrar()"
      style="margin-right: 8px;">

      Cancelar

    </button>

    <button
      nbButton
      shape="round"
      size="small"
      status="success"
      [disabled]="
        loading ||
        cargandoDatos ||
        !alias ||
        !codigoDGC ||
        cultivoSeleccionado == null ||
        variedadSeleccionada == null
      "
      (click)="guardar()">

      Guardar cambios

    </button>

  </nb-card-footer>

</nb-card>